import * as compiled from '../compiled-version';

/**
 * Version from package.json. It is written to compiled-version.js by writeversion.js, which the build pipeline runs
 * before every build. (Importing package.json directly would put all of it, scripts and devDependencies included,
 * in the public bundle.) The compiled-version.js in the repo is a stub, so local builds show `dev`.
 */
export const APP_VERSION: string = compiled.compiledVersion?.version ?? 'dev';

/** Build number of the pipeline; empty on local builds */
export const APP_BUILD: string | undefined = compiled.compiledVersion?.buildNumber;

/** e.g. `1.4.0+4521` (semver with the pipeline build as build metadata), `1.4.0` or `dev` */
export const APP_VERSION_LABEL = APP_BUILD ? `${APP_VERSION}+${APP_BUILD}` : APP_VERSION;
